<template>
  <div class="layout">
    <div style="position: fixed; left: 60px; top: 17px; z-index: 10000;">
      <el-button type="info" icon="el-icon-caret-left" size="small" @click="goback">返回</el-button>
    </div>
    <div style="position: relative; max-width: 888px; margin: 0 auto; padding-top: 45px;">
      <!-- <h2><span style="color: #409EFF;">{{ authname }}</span> 門市資訊</h2> -->
      <div style="position: absolute; right: 0px; top: 20px;">
        <span style="margin-right: 5px" v-if="storeList.length < maxItem">{{ storeList.length }}/{{ maxItem }}</span>
        <span style="margin-right: 5px; color: #f24;" v-else>{{ storeList.length }}/{{ maxItem }}</span>
        <el-tooltip class="item" effect="dark" :content="`門市上限為 ${maxItem} 組，如有需求可額外加購`" placement="top">
          <i class="el-icon-info" style="color: #777; transform: scale(1.1); cursor: pointer;"></i>
        </el-tooltip>
      </div>
      <el-table :data="storeList"
        height="calc(100vh - 270px)"
        :default-sort = "{prop: 'position', order: 'ascending'}"
        :empty-text="empty"
        style="margin: 0 auto; width: 100%; padding-bottom: 20px;">
        <!-- 門市名稱 -->
        <el-table-column label="順序"
          fixed
          width="50">
          <template slot-scope="scope">
            <div v-if="scope.$index !== 0" style="text-align: center; cursor: pointer; width: 30px; margin-bottom: -8px;"><i class="el-icon-caret-top" style="font-size: 25px; color: #00B900" @click="moveUp(scope.$index)"></i></div>
            <div style="text-align: center; cursor: pointer; width: 30px;">{{ scope.$index + 1 }}</div>
            <div v-if="scope.$index !== storeList.length - 1" style="text-align: center; cursor: pointer; width: 30px; margin-top: -8px;"><i class="el-icon-caret-bottom" style="font-size: 25px; color: #f24" @click="moveDown(scope.$index)"></i></div>
          </template>
        </el-table-column>
        <el-table-column label="門市名稱"
          fixed
          width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.Title }}</span>
            <!-- <el-input v-if="scope.row[1].Editable" v-model="scope.row[0]" size="small" placeholder="請輸入門市名稱"></el-input> -->
          </template>
        </el-table-column>
        <!-- 地址 -->
        <el-table-column label="門市資訊"
          width="300">
          <template slot-scope="scope">
            <div style="width: 32px; display: inline-block;">地址</div><i class="el-icon-caret-right"></i><span> {{ scope.row.Address || '未提供' }}</span><br>
            <div style="width: 32px; display: inline-block;">電話</div><i class="el-icon-caret-right"></i><span> {{ scope.row.truePhone || '未提供' }}</span><br>
            <div style="width: 32px; display: inline-block;">LINE</div><i class="el-icon-caret-right"></i><span> {{ scope.row.LINE || '未提供' }}</span>
            <!-- <el-input v-if="scope.row[1].Editable" v-model="scope.row[1].Address" size="small" placeholder="請輸入地址"></el-input> -->
          </template>
        </el-table-column>
        <!-- 店家端 -->
        <el-table-column label="店家端"
          width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.shopShow" style="width: 15px; height: 15px; background-color: #5DCD11; border-radius: 50%; margin-left: 12px;"></div>
            <div v-else style="width: 15px; height: 15px; background-color: #f24; border-radius: 50%; margin-left: 12px;"></div>
          </template>
        </el-table-column>
        <!-- 會員端 -->
        <el-table-column label="會員端"
          width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.userShow" style="width: 15px; height: 15px; background-color: #5DCD11; border-radius: 50%; margin-left: 12px;"></div>
            <div v-else style="width: 15px; height: 15px; background-color: #f24; border-radius: 50%; margin-left: 12px;"></div>
          </template>
        </el-table-column>
        <!-- LINE -->
        <el-table-column label="編輯"
          width="150">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" @click="openEdit(scope.$index)" size="small" plain></el-button>
            <el-button type="danger" icon="el-icon-close" size="small" @click="checkDelete(scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 編輯 -->
      <el-dialog title="編輯門市資料"
        :visible="openDia" v-if="storeList[storeIndex]">
        <div style="font-weight: 500; font-size: 16px; margin-bottom: 5px; color: #777;">名稱<i class="el-icon-caret-right"></i>
          <span style="color: #f24" v-if="showAlert">名稱不能為空!</span>
        </div>
        <el-input v-model="storeList[storeIndex].Title" placeholder="請輸入門市名稱"></el-input>
        <!-- 地址 -->
        <div style="font-weight: 500; font-size: 16px; margin-bottom: 5px; color: #777; margin-top: 20px;">地址<i class="el-icon-caret-right"></i></div>
        <el-input v-model="storeList[storeIndex].Address" placeholder="請輸入門市地址"></el-input>
        <!-- 電話 -->
        <div style="font-weight: 500; font-size: 16px; margin-bottom: 5px; color: #777; margin-top: 20px;">電話<i class="el-icon-caret-right"></i></div>
        <el-input v-model="storeList[storeIndex].truePhone" placeholder="請輸入門市電話"></el-input>
        <!-- LINE -->
        <div style="font-weight: 500; font-size: 16px; margin-bottom: 5px; color: #777; margin-top: 20px;">LINE<i class="el-icon-caret-right"></i></div>
        <el-input v-model="storeList[storeIndex].LINE" placeholder="請輸入門市 LINE"></el-input>
        <!-- LINE -->
        <div style="font-weight: 500; font-size: 16px; margin-bottom: 5px; color: #777; margin-top: 20px;">開關<i class="el-icon-caret-right"></i></div>
        <el-row>
          <el-col :span="12">
            <div style="padding: 10px; border: 1px solid #eee;">
              <span style="font-size: 16px; margin-right: 10px;">店家端</span>
              <el-switch v-model="storeList[storeIndex].shopShow"
                style="transform: translateY(-2px);"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="padding: 10px; border: 1px solid #eee;">
              <span style="font-size: 16px; margin-right: 10px;">用戶端</span>
              <el-switch v-model="storeList[storeIndex].userShow"
                style="transform: translateY(-2px);"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </div>
          </el-col>
        </el-row>
        <!-- 按鈕 -->
        <div style="margin-top: 20px; text-align: right;">
          <el-button type="primary" @click="closeDia">確認</el-button>
        </div>
      </el-dialog>
      <!-- 刪除資訊 -->
      <el-dialog title="確認訊息"
        :visible.sync="deleteDia"
        width="30%">
        <span>確定要刪除此門市資訊嗎</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDia = false">取 消</el-button>
          <el-button type="primary" @click="deleteItem">確 定</el-button>
        </span>
      </el-dialog>
      <div>
        <i class="el-icon-circle-plus-outline plus" @click="addStore"></i>
      </div>
      <div>
        <el-button type="danger" style="margin-top: 15px;" @click="sendUpdate">送出修改</el-button>
      </div>
      <mu-dialog :open.sync="resultDia" title="設定結果" width="500">
        {{ result }}
      </mu-dialog>
    </div>
    <div style="position: fixed; bottom: 10px; left: 20px; text-align: left;">
      <img src="https://i.imgur.com/SITKieL.png" width="120"/>
      <div style="padding-left: 12px; font-size: 13px;">Copyright © 2020 埃立思科技股份有限公司 版權所有</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable */
export default {
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      authname: '',
      empty: '載入中...',
      storeList: [],
      deleteIdx: 0,
      deleteDia: false,
      result: '',
      storeIndex: 0,
      showAlert: false,
      openDia: false,
      maxItem: 5,
      resultDia: false
    };
  },
  mounted() {
    this.checkWhiteList({ auth: this.auth, type: 'shopNum' }).then((resp) => {
      if (resp && resp.Detail) {
        this.maxItem = resp.Detail.num ? resp.Detail.num : 50;
      }
    })
    const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
    this.checkAccount({ Service: this.service, Auth: this.auth })
      .then((res) => {
        loading.close();
        this.authname = res.name;
        let storeArr = [];
        const allStore = res.store ? Object.entries(res.store).sort((a, b) => a[1].position - b[1].position) : [];
        if (allStore.length > 0) {
          for (let i = 0; i < allStore.length; i += 1) {
            storeArr[i] = {
              Title: allStore[i][0],
              Address: allStore[i][1].Address ? allStore[i][1].Address : '',
              LINE: allStore[i][1].LINE ? allStore[i][1].LINE : '',
              position: allStore[i][1].position ? allStore[i][1].position : i,
              truePhone: allStore[i][1].truePhone ? allStore[i][1].truePhone : '',
              shopShow: allStore[i][1].shopShow ? true : false,
              userShow: allStore[i][1].userShow ? true : false
            }
          }
          this.storeList = storeArr;
        }
        else {
          this.storeList = storeArr;
        }
        this.empty = '無門市資料';
      });
  },
  methods: {
    ...mapActions({
      checkAccount: 'checkAccount',
      checkWhiteList: 'checkWhiteList',
      updateAccount: 'updateAccount'
    }),
    goback() {
      this.$router.push(`/shoplist/?service=${this.service}&auth=${this.auth}`);
    },
    openEdit(index) {
      this.storeIndex = index;
      this.openDia = true;
    },
    closeDia() {
      if (!this.storeList[this.storeIndex] && this.storeList[this.storeIndex].Title === '') {
        this.showAlert = true;
      }
      else {
        this.showAlert = false;
        this.openDia = false;
      }
    },
    addStore() {
      this.storeList.push({
        Title: '門市Ａ',
        Address: '',
        truePhone: '',
        LINE: '',
        Editable: true,
        shopShow: true,
        userShow: true 
      });
    },
    moveDown(idx) {
      const thisStoreData = JSON.parse(JSON.stringify(this.storeList[idx]));
      const lowerStoreData = JSON.parse(JSON.stringify(this.storeList[idx + 1]));
      // 這一個往上移
      this.$set(this.storeList, idx, lowerStoreData);
      // 上一個往下移
      this.$set(this.storeList, idx + 1, thisStoreData);
    },
    moveUp(idx) {
      const thisStoreData = JSON.parse(JSON.stringify(this.storeList[idx]));
      const upperStoreData = JSON.parse(JSON.stringify(this.storeList[idx - 1]));
      // 這一個往上移
      this.$set(this.storeList, idx, upperStoreData);
      // 上一個往下移
      this.$set(this.storeList, idx - 1, thisStoreData);
    },
    checkDelete(idx) {
      this.deleteIdx = idx;
      this.deleteDia = true;
    },
    deleteItem() {
      this.deleteDia = false;
      this.storeList.splice(this.deleteIdx, 1);
    },
    sendUpdate() {
      const loading = this.$loading({ lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
      const sendContent = {};
      for (var i = 0; i < this.storeList.length; i += 1) {
        var storeKey = this.storeList[i].Title;
        var storeVal = this.storeList[i];
        sendContent[storeKey] = storeVal;
        sendContent[storeKey]['position'] = i;
      }
      this.updateAccount({ service: this.service, auth: this.auth, content: { store: sendContent } })
        .then((res) => {
          this.result = res.data.Message;
          this.resultDia = true;
          loading.close();
        });
    }
  }
}
</script>

<style scoped>
.layout {
  min-width: 100%;
  max-width: 100%;
  padding-top: 80px;
  margin-left: 0!important;
  flex: 1 1 100%;
}
.layout-66 {
  border-radius: 6px;
  background: #ffffff;
  height: 500px;
  min-width: 66.6666%;
  max-width: 66.6666%;
  flex: 0 1 66.6666%;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
.icon {
  display: inline-block;
  margin-right: 8px;
  transform: translateY(2px);
}
.plus:hover {
  color: rgb(64, 158, 255);
}
.plus {
  transition: 0.2s;
  cursor: pointer;
  font-size: 36px;
  margin-top: 10px;
  font-weight: 600;
  color: #777;
}
.column {
  padding: 15px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
  width: 90%;
  margin: 15px auto;
  text-align: left;
  cursor: pointer;
  transition: 0.3s;
}
.column:hover {
  transform: scale(1.05);
}
.layout-33 {
  height: 500px;
  background: #ffffff;
  min-width: 100px;
  max-width: 400px;
  flex: 0 1 33.3333%;
}
.contain {
  padding: 40px 65px;
}
.contain2 {
  padding: 20px;
  margin-bottom: 20px;
}
</style>